import OBase from './OBase';
import * as Geometry from '../geometry';

export default class Merge extends OBase {
  update () {
    let dataTrees = [];
    Object.keys(this.inputs).forEach(inputName => {
      let value = this.inputs[inputName];
      if (value !== null) {
        let dataTree = this.getObjectInput(inputName);
        // console.log(dataTree)
        if (dataTree instanceof Geometry.DataTree) {
          dataTrees.push(dataTree);
        }
      }
    });

    let output = this.outputs['Result'].paramObject;

    let outTree = new Geometry.DataTree();
    for (let i = 0; i < dataTrees.length; i++) {
      let dataTree = dataTrees[i];
      for (let j = 0; j < dataTree.branches.length; j++) {
        let path = dataTree.paths[j];
        if (dataTree.branches[j].length > 0) {
          for (let k = 0; k < dataTree.branches[j].length; k++) {
            let val = dataTree.branches[j][k];
            outTree.add(val, path);
          }
        } else {
          outTree.addEmpty(path);
        }
      }
    }
    outTree.sortPaths();
    output.value = outTree;

    if(this.ghGeometryObject.nickName == "debug")
    {
      console.log(output.value);
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/Merge.js